import watchEmployeesListSaga from './List/store/saga'
import watchEmployeesFormSaga from './Form/store/saga'

const root = [
  watchEmployeesListSaga(),
  watchEmployeesFormSaga(),
]

export default root
